module.exports = __webpack_public_path__ + "static/media/Lateral_Normal_Z1.243ee4b2.png";